<template>
  <v-card>
    <v-card-title :style="bannerStyle" class="py-1 px-4">
      <v-row align="center">
        <v-col cols="12" class="text-md-center py-0">
          <div>
            <h5 style="word-wrap: break-word;" :class="textStyle">{{section.title}}</h5>
          </div>
        </v-col>
      </v-row>
    </v-card-title>
    <v-tabs
      fixed-tabs
      :show-arrows="false"
      :slider-size="4"
      :dark="isDark"
      :color="isDark ? '' : 'secondary' "
      :slider-color="isDark ? 'yellow' : 'grey darken-2'"
      v-model="tab"
      v-if="morethan1tab"
    >
      <v-tab href="#tab-videos" class="tab-title" v-if="section.videos.required">
        <v-icon small>fa-play</v-icon>
        <span class="ml-2 d-none d-md-block" v-if="section.videos.multiple">Videos</span>
        <span class="ml-2 d-none d-md-block" v-else>Video</span>
      </v-tab>
      <v-tab href="#tab-photos" class="tab-title" v-if="section.photos.required">
        <v-icon small>fa-image</v-icon>
        <span class="ml-2 d-none d-md-block" v-if="section.photos.multiple">Photos</span>
        <span class="ml-2 d-none d-md-block" v-else>Photo</span>
      </v-tab>
      <v-tab href="#tab-documents" class="tab-title" v-if="section.documents.required">
        <v-icon small>fa-file-alt</v-icon>
        <span class="ml-2 d-none d-md-block" v-if="section.documents.multiple">Documents</span>
        <span class="ml-2 d-none d-md-block" v-else>Document</span>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-videos">
        <video-tab v-model="section.videos" :section="section"></video-tab>
      </v-tab-item>

      <v-tab-item value="tab-photos">
        <photo-tab v-model="section.photos" :section="section"></photo-tab>
      </v-tab-item>
      <v-tab-item value="tab-documents">
        <document-tab v-model="section.documents" :section="section"></document-tab>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import videoTab from "@/components/template/video-tab";
import photoTab from "@/components/template/photo-tab";
import documentTab from "@/components/template/document-tab";

export default {
  name: "PortalApplicantSection",
  props: ["value"],
  data() {
    return {
      tab: ""
    };
  },
  components: {
    videoTab,
    photoTab,
    documentTab
  },
  created() {
    this.setTab();
  },
  methods: {
    setTab() {
      if (this.section.videos.required) {
        this.tab = "tab-videos";
      } else if (this.section.photos.required) {
        this.tab = "tab-photos";
      } else if (this.section.documents.required) {
        this.tab = "tab-documents";
      }
    }
  },
  computed: {
    morethan1tab() {
      let count = 0;
      if (this.section.videos.required) {
        count += 1;
      }
      if (this.section.photos.required) {
        count += 1;
      }
      if (this.section.documents.required) {
        count += 1;
      }
      if (count > 1) {
        return true;
      }
      return false;
    },
    uploading_videos() {
      return this.video_uploads.filter(u => {
        return u.status !== "Done";
      });
    },
    section() {
      return this.value;
    },
    isDark() {
      return this.$helpers.lightOrDark(this.value.banner_color) === "dark";
    },
    isButtonDark() {
      return this.$helpers.lightOrDark(this.value.button_color) === "dark";
    },
    textStyle() {
      return this.isDark ? "white--text" : "secondary--text";
    },
    bannerStyle() {
      return `background: ${this.value.banner_color}`;
    }
  }
};
</script>

<style lang="scss">
.scroll-box {
  max-height: 350px;
  overflow-y: auto;
  overflow-x: hidden;
  @media only screen and (min-width: 768px) {
    max-height: 320px;
  }
  @media only screen and (min-width: 1920px) {
    max-height: 370px;
  }
  @media only screen and (max-width: 767px) {
    max-height: 250px;
  }
  @media only screen and (max-width: 767px) and (orientation: portrait) {
    max-height: 220px;
  }
}
</style>